<style scoped lang="scss">
    .recipients {
        width:100%;
        height:100%;
        background:#fff;
        &_group {
             margin-top:5px;
        }
        &_address {
            margin:-1px 0 -2px;
            dt {
                font-size: 16px;
                color: #000;
                font-weight: bold;
            }
            dd {
                color: #999;
                margin:0;
            }
        }
        &_left {
            width: calc(100% - 25px);
            float: left;
        }
        &_right {
            margin-top: 2px;
            width: 20px;
            float: right;
            text-align: right;
            i {
                font-size: 16px;
            }
        }
        &_buttons {
            padding: 15px;
            .van-button {
                margin-top:10px;
            }
        }
        &_upload_box {
            padding:0 15px 15px;
            .title {
                display: inline-block;
                padding: 6px 0;
            }
            .uploads {
                margin: 5px auto;
                width:100%;
                height:auto;
                min-height:100px;
                border:1px dashed #dddddd;
            }
            .uploads span {
                display: block;
                width:100%;
                height: 100%;
                text-align: center;
                i {
                    display: inline-block;
                    width:100%;
                    height:100px;
                    line-height: 100px;
                    font-style: normal;
                    color: #999;
                }
                img {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>
<style>
    .recipients_scope ul{
        overflow: auto!important;
    }
    .recipients_scope ul li{
        float: none!important;
        width: 100%!important;
        margin: 0!important;
        padding: 0!important;
        text-align: center!important;
        border-bottom:0!important;
        background:#fff;
    }
    .recipients_scope ul li:nth-child(odd) {
        border-right: 0!important;
        box-sizing: border-box;
    }
    .recipients_scope ul li a {
        display: block;
        color: #444;
    }
</style>
<template>
    <van-popup class="recipients recipients_scope" v-model="isChoiseReceiptor" position="right">
        <van-nav-bar title="选择收件人" />
        <div style="height: 50px;"></div>
        <van-search
            v-model="filter.Keywords"
            placeholder="姓名或电话号码"
            show-action
            shape="round"
            >
            <div slot="action" @click="closePopup">取消</div>
        </van-search>
        <van-tabs type="card" v-model="active" @click="addItem">
            <van-tab title="新增收件地址">
                <!--<van-address-edit
                    :area-list="areaDataList"
                    :address-info="areaInfo.addressee"
                    @save="onSaveAddress"
                    @change-area="changeArea"
                >

                </van-address-edit>-->
                <van-field
                    clearable
                    v-model="areaInfo.addressee.name"
                    label="姓名"
                    placeholder="请输入姓名"
                />
                <van-field
                    clearable
                    type="number"
                    v-model="areaInfo.addressee.tel"
                    label="电话"
                    placeholder="请输入电话"
                />
                <van-field
                    readonly=""
                    v-model="areaInfo.addressee.selectAreas"
                    label="地区"
                    placeholder="选择省 / 市 / 区"
                    @click="isShowArea = true"
                />
                <van-field
                    v-model="areaInfo.addressee.detail"
                    label="详细地址"
                    placeholder="街道、小区楼层等详细信息"
                />
                <van-field
                    clearable
                    v-model="areaInfo.addressee.idCardNo"
                    label="身份证号"
                    placeholder="请输入身份证号"
                />
                <div class="recipients_upload_box">
                    <span class="title">请上传身份证</span>
                    <van-uploader class="uploads"
                        accept="image/*"
                        :before-read="beforeAvatarUpload"
                        :after-read="idCardFrontImageSuccess"
                    >
                        <span>
                            <i v-if="!areaInfo.addressee.idCardFrontImageUrl">点击上传身份证人面像</i>
                            <img v-else :src="areaInfo.addressee.idCardFrontImageUrl" />
                        </span>
                    </van-uploader>
                    <van-uploader class="uploads"
                        accept="image/*"
                        :before-read="beforeAvatarUpload"
                        :after-read="idCardBackImageSuccess"
                    >
                        <span>
                            <i v-if="!areaInfo.addressee.idCardBackImageUrl">点击上传身份证国徽像</i>
                            <img v-else :src="areaInfo.addressee.idCardBackImageUrl" />
                        </span>
                    </van-uploader>
                </div>
                <div style="padding: 10px 15px;">
                    <van-button size="large" type="primary" @click="onSaveAddress">保存</van-button>
                </div>
                <van-popup v-model="isShowArea" :close-on-click-overlay="false" :lock-scroll="true" position="bottom">
                    <van-area :area-list="areaDataList" :value="areaInfo.addressee.area"
                    cancel-button-text="关闭"
                    @confirm="changeArea" @cancel="clearArea" />
                </van-popup>
            </van-tab>
            <van-tab title="选择已有地址">
                <van-cell-group class="recipients_group">
                    <template v-if="addressList && addressList.length > 0">
                        <van-cell :key="index" v-for="(item, index) in addressList">
                            <dl class="recipients_address recipients_left" @click="choiseItem(item)">
                                <dt>{{item.addressee && item.addressee.name}} {{item.addressee && item.addressee.tel}}</dt>
                                <dd>{{item.addressee.fullAddress}}</dd>
                            </dl>
                            <dl class="recipients_address recipients_right">
                                <dt @click="editItem(item)"><van-icon name="edit" /></dt>
                                <dd @click="deleteItem(item, index)"><van-icon name="delete" /></dd>
                            </dl>
                        </van-cell>
                    </template>
                    <div v-else style="text-align: center; height: 3rem; line-height: 3rem;">~暂无数据~</div>
                </van-cell-group>
            </van-tab>
        </van-tabs>
    </van-popup>
</template>

<script>
    import lrz from 'lrz'
    import areaData from '@/js/area.js'
    import { Checkbox, CheckboxGroup, Card, SubmitBar, Stepper, AddressEdit, AddressList, Area, ContactEdit, Tab, Tabs, Panel, Field, Icon } from 'vant'
    export default {
        name: 'cpnReceiptor',
        props: {
            'isChoiseReceiptor': {
                default: false,
                type: Boolean
            }
        },
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [SubmitBar.name]: SubmitBar,
            [CheckboxGroup.name]: CheckboxGroup,
            [Stepper.name]: Stepper,
            [AddressEdit.name]: AddressEdit,
            [AddressList.name]: AddressList,
            [Area.name]: Area,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [ContactEdit.name]: ContactEdit,
            [Panel.name]: Panel,
            [Field.name]: Field,
            [Icon.name]: Icon
        },
        data () {
            return {
                active: 1,
                areaDataList: [],
                filter: {
                    Keywords: "",
                    Page: 1,
                    Size: 10000
                },
                isShowArea: false,
                addressList: [],
                areaInfo: {
                    "id": 0,
                    "addressee": {
                        "name": "",
                        "tel": "",
                        "province": "",
                        "city": "",
                        "area": "",
                        "detail": "",
                        "idCardNo": "",
                        "idCardFrontImageUrl": "",
                        "idCardBackImageUrl": "",
                        "addressDetail": "",
                        "selectAreas": ""
                    },
                    "memberId": 0
                },
                editModel: {
                    "addressee": {
                        "name": "",
                        "tel": "",
                        "province": "",
                        "city": "",
                        "area": "",
                        "detail": "",
                        "idCardNo": "",
                        "idCardFrontImageUrl": "",
                        "idCardBackImageUrl": ""
                    },
                    "id": 0,
                    "memberId": 0
                }
            }
        },
        watch: {
            "filter.Keywords"() {
                this.searchAddress()
            },
            isChoiseReceiptor(v) {
                if (v) {
                    this.getAddressee();
                }
            }
        },
        async mounted () {
            await areaData.getAreasData().then(() => {
                this.areaDataList = areaData.getVantArea()
            })
            this.getAddressee();
        },
        methods: {
            getAddressee() {
                this.addressList = []
                this.showH5Loading()
                this.$axios.get(window.consts.apis.getAddresses, { params: this.filter }).then(res => {
                    this.hideH5Loading();
                    if (res.success) {
                        for (var i in res.result.items) {
                            var item = res.result.items[i];
                            var provinceName = this.areaDataList.province_list[item.addressee.province] || "";
                            var cityName = this.areaDataList.city_list[item.addressee.city] || "";
                            var areaName = this.areaDataList.county_list[item.addressee.area] || "";
                            this.addressList[i] = item;
                            this.addressList[i].id = item.id;
                            this.addressList[i].memberId = item.memberId;
                            this.addressList[i].addressee.fullAddress = `${provinceName} ${cityName} ${areaName} ${item.addressee.detail}`;
                            this.addressList[i].addressee.selectAreas = `${provinceName} / ${cityName} / ${areaName}`;
                            this.addressList[i].addressee.addressDetail = item.addressee.detail;
                        }
                        this.addressList = res.result.items;
                    } else {
                        this.$dialog.alert({ message: res.error.message });
                        return false;
                    }
                }).catch(e => {
                    this.hideH5Loading();
                    this.$toast.fail("出错啦，请稍候再试!");
                    return false;
                });
            },
            //搜索
            searchAddress() {
                this.active = 1
                this.getAddressee()
            },
            //保存
            onSaveAddress() {
                var item = this.areaInfo.addressee;
                var valid = window.consts.validate;
                if (!item.name) {
                    this.$toast.fail("请输入姓名!");
                    return false;
                } else if (!item.tel) {
                    this.$toast.fail("手机号码格式错误!");
                    return false;
                } else if (!item.selectAreas) {
                    this.$toast.fail("请选择地区!");
                    return false;
                } else if (!item.detail || item.detail == item.selectAreas.replace(/\s\/\s/g, "")) {
                    this.$toast.fail("请填写详细地址!");
                    return false;
                }
                /*else if (!valid.idCard.test(item.idCardNo)) {
                    this.$toast.fail("身份证格式错误!");
                    return false;
                }*/
                /*else if (!item.idCardFrontImageUrl || !item.idCardBackImageUrl) {
                    this.$toast.fail("请上传身份证图片!");
                    return false;
                }*/
                this.editModel.id = this.areaInfo.id;
                this.editModel.memberId = this.areaInfo.memberId;
                for (var i in this.editModel.addressee) {
                    this.editModel.addressee[i] = this.areaInfo.addressee[i];
                }
                this.showH5Loading()
                this.$axios.post(window.consts.apis.saveAddressee, {
                    id: this.editModel.id,
                    memberId: this.editModel.memberId,
                    addressee: this.editModel.addressee
                }).then(r => {
                    this.hideH5Loading()
                    if (r.success) {
                        this.$toast.success({
                            duration: 2000,
                            forbidClick: true,
                            loadingType: 'spinner',
                            message: this.editModel.id > 0 ? "修改成功" : "添加成功",
                            onClose: (rt => {
                                this.active = 1;
                                this.getAddressee();
                            })
                        });
                    } else {
                        this.$dialog.alert({ message: r.error.message });
                        return false;
                    }
                }).catch(e => {
                    this.hideH5Loading();
                    this.$toast.fail("出错啦，请稍候再试!");
                    return false;
                })
            },
            //选中省市区
            changeArea(values) {
                if (values && values.length > 0) {
                    this.areaInfo.addressee.selectAreas = `${values[0].name} / ${values[1].name} / ${values[2].name}`;
                    this.areaInfo.addressee.province = values[0].code;
                    this.areaInfo.addressee.city = values[1].code;
                    this.areaInfo.addressee.area = values[2].code;
                    // this.areaInfo.addressee.detail = `${values[0].name}${values[1].name}${values[2].name}`;
                    this.areaInfo.addressee.detail = ""
                } else {
                    this.areaInfo.addressee.selectAreas = "";
                    this.areaInfo.addressee.province = "";
                    this.areaInfo.addressee.city = "";
                    this.areaInfo.addressee.area = "";
                    this.areaInfo.addressee.detail = "";
                }
                this.isShowArea = false
            },
            //清除省市区
            clearArea() {
                this.isShowArea = false
            },
            //图片上传之前
            beforeAvatarUpload (file) {
                /*const isLt2M = file.size / 1024 / 1024 < 5
                if (!isLt2M) {
                    this.$toast.fail('身份证图片大小不能超过5MB!')
                    return false
                }*/
                return true
            },
            //身份证人面像
            idCardFrontImageSuccess (res, file) {
                this.showH5Loading()
                lrz(res.file, {
                    width: 1000,
                    quality: 0.7
                }).then(rst => {
                    let fd = new FormData()
                    fd.append("File", res.file)
                    this.$axios.post(window.consts.apis.uploadFile, rst.formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            "Authorization": this.uploadHeaders.Authorization
                        }
                    }).then(r => {
                        this.hideH5Loading()
                        if (r.success) {
                            this.areaInfo.addressee.idCardFrontImageUrl = r.result.fileUrl
                        } else {
                            this.$toast.fail(r.error.message)
                        }
                    }, error => {
                        this.hideH5Loading()
                        this.$toast.fail("身份证上传失败，请重试!")
                    })
                }).catch(e => {
                    this.hideH5Loading()
                    this.$toast.fail("上传出错啦，请重试!")
                })
            },
            //身份证国徽像
            idCardBackImageSuccess (res, file) {
                this.showH5Loading()
                lrz(res.file, {
                    width: 1000,
                    quality: 0.7
                }).then(rst => {
                    let fd = new FormData()
                    fd.append("File", res.file)
                    this.$axios.post(window.consts.apis.uploadFile, rst.formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            "Authorization": this.uploadHeaders.Authorization
                        }
                    }).then(r => {
                        this.hideH5Loading()
                        if (r.success) {
                            this.areaInfo.addressee.idCardBackImageUrl = r.result.fileUrl
                        } else {
                            this.$toast.fail(r.error.message)
                        }
                    }, error => {
                        this.hideH5Loading()
                        this.$toast.fail("身份证上传失败，请重试!")
                    })
                }).catch(e => {
                    this.hideH5Loading()
                    this.$toast.fail("上传出错啦，请重试!")
                })
            },
            //选中传到父级
            choiseItem(item) {
                this.$emit("choisedReceiptor", item);
            },
            //新增地址
            addItem() {
                if (this.active === 0) {
                    this.areaInfo.id = 0;
                    this.areaInfo.memberId = 0;
                    for (var i in this.areaInfo.addressee) {
                        this.areaInfo.addressee[i] = "";
                    }
                }
            },
            //编辑
            editItem(item) {
                this.active = 0;
                for (var i in this.areaInfo) {
                    this.areaInfo[i] = JSON.parse(JSON.stringify(item[i]));
                }
            },
            //删除
            deleteItem(item, index) {
                this.$dialog.confirm({
                    message: '确定要删除联系人吗？'
                }).then(() => {
                    this.showH5Loading();
                    this.$axios.delete(window.consts.apis.deleteAddressee, { params: { id: item.id } }).then(res => {
                        this.hideH5Loading();
                        if (res.success) {
                            this.$toast.success({
                                duration: 2000,
                                forbidClick: true,
                                loadingType: 'spinner',
                                message: "删除成功!",
                                onClose: (rt => {
                                    this.addressList.splice(index, 1);
                                })
                            });
                        } else {
                            this.$dialog.alert({ message: res.error.message });
                            return false;
                        }
                    }).catch(e => {
                        this.hideH5Loading();
                        this.$toast.fail("出错啦，请稍候再试!");
                        return false;
                    });
                }).catch(() => {

                });
            },
            //取消，关闭
            closePopup() {
                this.$emit('closeRecPopup', false);
            }
        }

    }
</script>


